import {Box, HBox} from '@buncha/components/core/view';
import {CustomText, H5Text} from '@buncha/components/core/text';
import {useColorThemeType, useFontTheme} from '@buncha/appStyles/hooks/theme';

import ProfileIcon from '@buncha/components/core/icon/ProfileIcon';
import React from 'react';
import {scaleFonts} from '@buncha/appStyles/style/font';
import {styles} from './styles';

interface UserHeaderProps {
  buyerName: string;
  subText: string;
  leftComponent?: React.ReactNode;
}

const UserHeader: React.FC<UserHeaderProps> = props => {
  const {buyerName, subText, leftComponent} = props;

  const muliFont = useFontTheme('muli');
  const theme = useColorThemeType();
  return (
    <HBox style={styles.container}>
      <HBox style={styles.subContainer}>
        <ProfileIcon
          width={scaleFonts(30)}
          height={scaleFonts(40)}
          viewBox="-3 -1 25 25"
          fill={theme?.text.blue[300]}
        />
        <Box style={styles.nameContainer}>
          <H5Text
            style={[
              styles.nameText,
              {
                fontFamily: muliFont[700].normal,
                color: theme?.text.blue[300],
              },
            ]}>
            {buyerName}
          </H5Text>
          <CustomText
            style={[
              styles.nameText,
              {
                fontFamily: muliFont[600].normal,
                color: theme?.text.gray[100],
              },
            ]}>
            {subText}
          </CustomText>
        </Box>
      </HBox>
      <HBox style={styles.leftContainer}>{leftComponent}</HBox>
    </HBox>
  );
};

export default React.memo(UserHeader);
